/**
 * Lightweight in-memory TTL cache used to prefetch admin data (shipments,
 * pickups) from the Dashboard so that navigating to those pages feels
 * instant. Each entry stores `{ data, total, expires }`.
 *
 * Usage:
 *   setCache(key, data, total);   // called after a successful GET
 *   const hit = getCache(key);    // returns { data, total } or null
 *   invalidate("/admin/pickups"); // wipe all entries starting with prefix
 */
const cache = new Map();
const TTL_MS = 30 * 1000; // 30 seconds — long enough to save the click, short enough to stay fresh

export function setCache(key, data, total) {
  cache.set(key, { data, total, expires: Date.now() + TTL_MS });
}

export function getCache(key) {
  const entry = cache.get(key);
  if (!entry) return null;
  if (Date.now() > entry.expires) {
    cache.delete(key);
    return null;
  }
  return { data: entry.data, total: entry.total };
}

export function invalidate(prefix) {
  for (const k of Array.from(cache.keys())) {
    if (k.startsWith(prefix)) cache.delete(k);
  }
}
